import { PreviewPaneBloc } from "../../PreviewPaneBloc";
import styles from "./Appearance.module.scss";
import { DesignTemplate } from "./DesignTemplate";
import { FontStyle } from "./FontStyle";

export function Appearance(props: { bloc: PreviewPaneBloc }) {
  return (
    <div className={styles.Appearance}>
      <div className={styles.title}>APPEARANCE</div>
      <DesignTemplate bloc={props.bloc} />
      <FontStyle bloc={props.bloc} />
    </div>
  );
}
